import { useState, useEffect, useRef } from 'react'
import { useRecaptcha } from 'react-hook-recaptcha'
import { useForm, Controller } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import envConfig from '../../utils/configEnv/config'
import { TextField, Typography, Button, InlineAlert } from '@nwh-consumer-digital/nw-component-lib'
import styled from '@emotion/styled'
import { Grid, Box, Paper } from '@mui/material'

const Item = styled(Paper)(({ theme }) => ({
  textAlign: 'left',
  maxWidth: '400px',
  marginBottom: '16px', // There is an extra 6 pixels this makes 24px
}))
const containerId = 'test-recaptcha'
const sitekey = envConfig?.REACT_APP_GOOGLERECAPTCHASITEKEY
const dpxURL = 'https://' + envConfig?.REACT_APP_DPXURL
const generateLiteTokenURL = dpxURL + '/iforms/generateLiteToken'
const updateAuthContact = dpxURL + '/iforms/updateAuthandContact'
const iformHeaders = new Headers()
iformHeaders.append('Content-Type', 'application/json')

const isValidEmail = (email) =>
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email,
  )
const postProxyVerificationEmailURL = dpxURL + '/carereadyapps/postProxyVerificationEmail'

//Post Email To postProxyVerificationEmailURL
const postEmailRequest = async (postData) => {
  const myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  myHeaders.append(
    'Cookie',
    'incap_ses_132_2194498=cxtBGpEhuWDDp3u1WPXUAdApiWgAAAAABJT4wGr3hTSfXvHQ6/tcoQ==; nlbi_2194498=RydfGXqTgzJsY0tz8KXiMAAAAACF9cLin+vPFM9BY24249IS; visid_incap_2194498=YncwWK6QQsC6LpaCKvGOiWy6h2gAAAAAQUIPAAAAAACIMOTNxKVqzga000CVf5Pl',
  )
  const res = await fetch(postProxyVerificationEmailURL, {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify(postData),
  })
  return res
}

export default function emailFormVerification({ formId, fmhFormType, locale }) {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const navigate = useNavigate()
  async function dpxSetAccountInfo(formData) {
    if (isSubmitting) return // Prevent multiple submissions
    setIsSubmitting(true)
    let payload = JSON.stringify({
      email: formData.email,
      firstName: formData.fname,
      lastName: formData.lname,
      formid: formId,
      appdomain: dpxURL,
    })
    try {
      const res = await fetch(generateLiteTokenURL, {
        method: 'post',
        headers: iformHeaders,
        body: payload,
      })

      if (!res.ok) {
        navigate('/Error/' + 'Set Account Issue ' + res.statusText)
      }
      const resposneData = await res.json()
      await dpxSendInvite(resposneData.postGenerateLiteTokenResponse, formData, locale)
    } catch (err) {
      navigate('/Error/' + 'Account Creation Error ' + err)
    }
  }

  async function dpxSendInvite(postGenerateLiteTokenResponse, formData, locale) {
    let payload = JSON.stringify({
      externalid: postGenerateLiteTokenResponse.externalid,
      email: postGenerateLiteTokenResponse.email,
    })
    try {
      const res = await fetch(updateAuthContact, {
        method: 'post',
        headers: iformHeaders,
        body: payload,
      })

      if (!res.ok) {
        navigate('/Error/' + 'Account Invite Error ')
      }

      //Fix Post Data To Match Changes in DPX Scaffolding
      const postData = {
        patientEmail: postGenerateLiteTokenResponse.email,
        firstname: postGenerateLiteTokenResponse.firstname,
        lastName: postGenerateLiteTokenResponse.lastname,
        externalId: postGenerateLiteTokenResponse.externalid,
        formId: formId,
      }

      const postEmailReqResults = await postEmailRequest(postData)

      if (postEmailReqResults) {
        navigate('/EmailNotification/' + formData.email)
      }
    } catch (err) {
      navigate('/Error/' + 'Account Invite Error ' + err)
    }
  }

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm()
  const [captchaResponse, setCaptchaResponse] = useState(null)
  const handleEmailValidation = (email) => {
    const isValid = isValidEmail(email)
    const validityChanged = (errors.email && isValid) || (!errors.email && !isValid)
    if (validityChanged) {
    }
    return isValid
  }

  // Count the number of errors on the page and, if any are found, scroll to the reference above the inline alert box after tallying them.
  const errorCount = Object.keys(errors).length
  const targetRef = useRef(null)
  const scrollToTarget = () => {
    if (targetRef.current) {
      targetRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }
  useEffect(() => {
    if (errorCount > 0) {
      scrollToTarget()
    }
  }, [errors])

  const successCallback = (response) => {
    setCaptchaResponse(response)
  }

  const handleRegistration = (data) => {
    dpxSetAccountInfo(data)
  }

  const expiredCallback = () => setCaptchaResponse(null)

  useRecaptcha({
    containerId,
    successCallback,
    expiredCallback,
    size: 'normal',
    sitekey,
  })

  return (
    <Box className="pageContainer">
      <Grid container direction="column" justifyContent="space-between" alignItems="left">
        <Grid item>
          <Typography
            variant="h1"
            sx={{
              marginTop: { xs: '1.25rem', sm: '1.25rem', md: '1.25rem', lg: '5rem', xl: '5rem' },
              marginBottom: { xs: '2rem', sm: '2rem', md: '2rem', lg: '2rem', xl: '2rem' },
            }}>
            Enter your details
          </Typography>
        </Grid>
        <form onSubmit={handleSubmit(handleRegistration)}>
          <Grid item xs={12} className="requiredSpacing">
            <Item elevation={0}>
              <label ref={targetRef} className="required">
                <span className="red">*</span> Required
              </label>
            </Item>
          </Grid>
          {errorCount > 0 && (
            <Grid item xs={12}>
              <Item elevation={0}>
                <InlineAlert severity="error" fullWidth text={`There are ${errorCount} errors on this page.`} />
              </Item>
            </Grid>
          )}
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="fname"
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Z a-z]*$/i,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="fname"
                    autocomplete="given-name"
                    onChange={onChange}
                    label={
                      <span>
                        First Name <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.fname)}
                    helperText={
                      errors?.fname
                        ? errors?.fname?.type === 'required'
                          ? 'First name is required'
                          : errors?.fname?.type === 'pattern'
                          ? 'First name contains invalid characters.'
                          : 'First name is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="lname"
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Z a-z]*$/i,
                }}
                autocomplete="family-name"
                render={({ field: { onChange } }) => (
                  <TextField
                    id="lname"
                    onChange={onChange}
                    label={
                      <span>
                        Last Name <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.lname)}
                    helperText={
                      errors?.lname
                        ? errors?.lname?.type === 'required'
                          ? 'Last name is required'
                          : errors?.lname?.type === 'pattern'
                          ? 'Last name contains invalid characters.'
                          : 'Last name is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <Controller
                name="email"
                control={control}
                rules={{
                  required: true,
                  pattern: /^[A-Z a-z0-9@.!#$%&'*+-/=?^_`{|}~]*$/i,
                  maxLength: 122,
                  validate: handleEmailValidation,
                }}
                render={({ field: { onChange } }) => (
                  <TextField
                    id="email"
                    onChange={onChange}
                    autocomplete="off"
                    label={
                      <span>
                        Email address <span className="red">*</span>
                      </span>
                    }
                    fullWidth
                    error={Boolean(errors?.email)}
                    helperText={
                      errors?.email
                        ? errors?.email?.type === 'required'
                          ? 'Email address is required.'
                          : errors?.email?.type === 'pattern'
                          ? 'Please use alphabetic characters only'
                          : errors?.email?.type === 'validate'
                          ? 'Enter a valid email address in format: example@example.com'
                          : 'Email address is required.'
                        : ''
                    }
                  />
                )}
              />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item elevation={0}>
              <div id={containerId} className="g-recaptcha recaptchaSpace" />
              <Button disabled={!captchaResponse || isSubmitting} text="Continue" color="primary" type="submit" />
            </Item>
          </Grid>
        </form>
      </Grid>
    </Box>
  )
}
